import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { startCase } from "lodash";

const SectionHeader:React.FC<{ title: string, description: string }> =
({ title, description }) => (
  <Grid item xs={12}>
    <Typography variant="h6">{startCase(title)}</Typography>
    <Typography paragraph>{description}</Typography>
    <hr />
  </Grid>
);

export default SectionHeader;
